import { emptysDates } from "../data/main";

export const convertAge = (d1: string, d2: string | boolean = false) => {
  // Asegurar que date1 sea la menor
  try {
    if (!emptysDates.includes(d1)) {
      let date1 = new Date(d1);
      let date2 = typeof d2 === "string" ? new Date(d2) : new Date();
      if (date1 > date2) {
        [date1, date2] = [date2, date1];
      }

      let years = date2.getFullYear() - date1.getFullYear();
      let months = date2.getMonth() - date1.getMonth();
      let days = date2.getDate() - date1.getDate();

      // Ajuste de días negativos
      if (days < 0) {
        months--;
        // Tomar el último día del mes anterior a date2
        const prevMonth = new Date(date2.getFullYear(), date2.getMonth(), 0);
        days += prevMonth.getDate();
      }

      // Ajuste de meses negativos
      if (months < 0) {
        years--;
        months += 12;
      }

      return [years, months, days];
    }
  } catch (error) {
    console.log("convertAge error: ", error);
  }
  return false;
};
